import React from 'react';
import { useSelector } from 'react-redux';

import TooltipWrapper from 'dpl/common/tooltip/components/TooltipWrapper';
import Icon from 'dpl/common/components/Icon';

export default function BreederProfileBreedNonstandardTooltip() {
  const {
    nonStandard,
    hasNonStandard,
    standardText,
    nonStandardText,
    standardPath,
    nonStandardPath
  } = useSelector(state => state.server);

  if (!hasNonStandard) {
    return null;
  }

  return (
    <div className="BreederProfileBreedNonstandardTooltip">
      <div className="f2 mid-gray">
        {nonStandard ? (
          <span>
            <TooltipWrapper
              className="v-mid pr2 pb1"
              minWidth="300px"
              title={
                /* eslint-disable-next-line react/no-danger */
                <span dangerouslySetInnerHTML={{ __html: nonStandardText }} />
              }
            >
              <Icon name="help-16" width="14px" />
            </TooltipWrapper>
            <span className="v-mid">
              *Including non-standard breed attributes
            </span>
            <a
              href={standardPath}
              className="underline v-mid pl4 pt2"
              target="_blank"
              rel="noopener noreferrer"
            >
              View standard
            </a>
          </span>
        ) : (
          <span>
            <TooltipWrapper
              className="v-mid pr2 pb1"
              minWidth="300px"
              title={
                /* eslint-disable-next-line react/no-danger */
                <span dangerouslySetInnerHTML={{ __html: standardText }} />
              }
            >
              <Icon name="help-16" width="14px" />
            </TooltipWrapper>
            <span className="v-mid">Breed standard</span>
            <a
              href={nonStandardPath}
              className="underline v-mid pl4 pt2"
              target="_blank"
              rel="noopener noreferrer"
            >
              View non-standard
            </a>
          </span>
        )}
      </div>
    </div>
  );
}
